module.exports = __webpack_public_path__ + "static-portal/img/icon-03.e650be4.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/HomeManage/module/icons/icon-03.png
// module id = HRw+
// module chunks = 4